// PGCET MCA Mock 3 — General Awareness (questions 71–90). 71–73 are from the
// Karnataka PGCET 2026 MCA paper; the rest fill out the section in the same style.
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: `Which of the following statements are correct?
      (a) Startups are innovation-driven businesses and aim at scalability.
      (b) The Securities and Exchange Board of India regulates stock markets and protects investors.
      (c) GST is an indirect tax applicable across India and is collected only once, at the final stage of the transaction.
      (d) Blinkit operates in quick commerce, which focuses on fast delivery using dark stores.`,
    options: ["A. (a), (b) and (c)", "B. (a), (b) and (d)", "C. (b), (c) and (d)", "D. (c) and (d) only"],
    answer: "B"
  },
  {
    id: 72,
    question: `Which of the following statements about the consumer-to-consumer (C2C) e-business model are correct?
      (a) It involves transactions between two consumers.
      (b) Online platforms like OLX facilitate C2C trade.
      (c) It reduces dependency on traditional retailers.
      (d) Businesses directly supply goods and services to customers in this model.`,
    options: ["A. (a), (b) and (c)", "B. (a) and (b) only", "C. (b), (c) and (d)", "D. (c) and (d) only"],
    answer: "A"
  },
  {
    id: 73,
    question: "Which of the following is NOT an advantage of a business letter?",
    options: [
      "A. It has a wide reach",
      "B. It can be a standalone medium",
      "C. It is not cost-effective",
      "D. It can be reproduced and repeated"
    ],
    answer: "C"
  },
  {
    id: 74,
    question: "Which Article of the Constitution of India lays down the procedure for the impeachment of the President?",
    options: ["A. Article 52", "B. Article 61", "C. Article 72", "D. Article 356"],
    answer: "B"
  },
  {
    id: 75,
    question: `Consider the following statements about the Rajya Sabha.
      (a) It is a permanent body and is not subject to dissolution.
      (b) One-third of its members retire every second year.
      (c) The Vice-President of India is its ex-officio Chairman.
      Which of the statements are correct?`,
    options: ["A. (a) and (b) only", "B. (b) and (c) only", "C. (a) and (c) only", "D. (a), (b) and (c)"],
    answer: "D"
  },
  {
    id: 76,
    question: `Match List-I with List-II.
      List-I: (a) Article 14 (b) Article 17 (c) Article 32 (d) Article 51A
      List-II: (i) Abolition of untouchability (ii) Equality before law (iii) Fundamental duties (iv) Right to constitutional remedies`,
    options: [
      "A. a-ii, b-i, c-iv, d-iii",
      "B. a-i, b-ii, c-iv, d-iii",
      "C. a-ii, b-i, c-iii, d-iv",
      "D. a-iv, b-iii, c-ii, d-i"
    ],
    answer: "A"
  },
  {
    id: 77,
    question: "Which of the following is NOT a function of the Reserve Bank of India?",
    options: [
      "A. Issuing currency notes",
      "B. Acting as banker to the government",
      "C. Accepting savings deposits from the general public",
      "D. Acting as the lender of last resort to banks"
    ],
    answer: "C"
  },
  {
    id: 78,
    question: "The Cash Reserve Ratio (CRR) is the share of a bank's net demand and time liabilities that it must",
    options: [
      "A. invest in government securities, gold and cash",
      "B. keep as a cash balance with the RBI",
      "C. lend to priority sectors such as agriculture",
      "D. pay to the RBI as an annual fee"
    ],
    answer: "B"
  },
  {
    id: 79,
    question: "The term 'stagflation' describes an economy experiencing",
    options: [
      "A. slow economic growth together with high inflation and unemployment",
      "B. rapid economic growth with falling prices",
      "C. a sustained fall in the general price level",
      "D. inflation caused only by excess demand"
    ],
    answer: "A"
  },
  {
    id: 80,
    question: "NITI Aayog replaced the Planning Commission of India in",
    options: ["A. 2014", "B. 2015", "C. 2016", "D. 2017"],
    answer: "B"
  },
  {
    id: 81,
    question: "Which of the following is NOT a greenhouse gas?",
    options: ["A. Methane", "B. Nitrous oxide", "C. Nitrogen", "D. Carbon dioxide"],
    answer: "C"
  },
  {
    id: 82,
    question: "The blue colour of the clear sky is due to",
    options: ["A. total internal reflection", "B. dispersion of light", "C. diffraction of light", "D. scattering of light"],
    answer: "D"
  },
  {
    id: 83,
    question: "Insulin is secreted by the",
    options: [
      "A. liver",
      "B. adrenal cortex",
      "C. beta cells of the islets of Langerhans in the pancreas",
      "D. alpha cells of the islets of Langerhans in the pancreas"
    ],
    answer: "C"
  },
  {
    id: 84,
    question: "Aditya-L1, India's first space-based solar observatory, is placed in a halo orbit around",
    options: [
      "A. the Moon's south pole",
      "B. the Sun–Earth Lagrange point L1",
      "C. a geostationary orbit above India",
      "D. the Earth–Moon Lagrange point L2"
    ],
    answer: "B"
  },
  {
    id: 85,
    question: "Which of the following rivers flows westward and drains into the Arabian Sea?",
    options: ["A. Godavari", "B. Krishna", "C. Mahanadi", "D. Narmada"],
    answer: "D"
  },
  {
    id: 86,
    question: "The Tropic of Cancer does NOT pass through which of the following states?",
    options: ["A. Odisha", "B. Tripura", "C. Jharkhand", "D. Mizoram"],
    answer: "A"
  },
  {
    id: 87,
    question: "The Krishna Raja Sagara (KRS) dam in Karnataka is built across the river",
    options: ["A. Kaveri", "B. Tungabhadra", "C. Krishna", "D. Sharavati"],
    answer: "A"
  },
  {
    id: 88,
    question: "The Global Innovation Index is published annually by",
    options: ["A. the World Bank", "B. the World Intellectual Property Organization (WIPO)", "C. the International Monetary Fund", "D. the World Economic Forum"],
    answer: "B"
  },
  {
    id: 89,
    question: "The 'Basel III' norms are related to",
    options: [
      "A. allocation of telecom spectrum",
      "B. nuclear non-proliferation",
      "C. protection of wetlands",
      "D. capital adequacy and liquidity requirements for banks"
    ],
    answer: "D"
  },
  {
    id: 90,
    question: "The Dronacharya Award is given in India for",
    options: [
      "A. excellence in sports coaching",
      "B. lifetime achievement in literature",
      "C. gallantry in peacetime",
      "D. excellence in school teaching"
    ],
    answer: "A"
  }
];

export default pgcetmcaGeneralAwareness;
